import React from "react";
import ReactDOM from "react-dom/client";
import "@/styles/theme.css";
import "@/styles/design_tokens.css";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Read saved theme or default to dark
const savedTheme = localStorage.getItem("askstewie-theme") || "dark";
document.documentElement.setAttribute("data-theme", savedTheme);
document.documentElement.classList.add(savedTheme);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
